<template>
	<div>
		<div
				id="secondary-nav-backdrop"
				:class="{ show: isOpen && $vuetify.breakpoint.mdAndDown }"
		></div>
		<v-navigation-drawer
				id="secondary-nav"
				ref="secondaryNav"
				v-model="isOpen"
				v-click-outside="() => clickOutsideOptions"
				aria-label="Secondary Navigation"
				class="grey lighten-5"
				hide-overlay
				:permanent="$vuetify.breakpoint.lgAndUp"
				tag="nav"
				:temporary="$vuetify.breakpoint.mdAndDown"
				:width="300"
				style="overflow: unset !important;"
		>
			<div v-if="$vuetify.breakpoint.mdAndDown" class="close_btn_well">
				<v-btn
						v-reveal-btn-label="'Close'"
						color="#e5e5e5"
						depressed
						fab
						@click="() => isOpen = false"
				>
					<v-icon>mdi-menu-open</v-icon>
				</v-btn>
			</div>
			<v-container>
				<v-row>
					<v-col>
						<template v-for="(comp, idx) in menu">
							<component
									v-bind="$attrs"
									v-on="$listeners"
									:is="components[comp.type]"
									:data="comp"
									:isAdmin="isAdmin"
							/>
						</template>
					</v-col>
				</v-row>
			</v-container>
		</v-navigation-drawer>
	</div>
</template>

<script>
import Breadcrumb from './components/Breadcrumb.vue';
import MenuImage from './components/MenuImage.vue';
import Menus from './components/Menus.vue';
import Section from './components/Section.vue';
import Stepper from './components/Stepper.vue';
import VenueInfo from './components/VenueInfo.vue';
export default {
	name: 'SecondaryNav',
	props: {
		menuData: {
			type: Array,
			default: () => []
		},
		user: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			components: {
				breadcrumb: Breadcrumb,
				menu_image: MenuImage,
				menus: Menus,
				section: Section,
				stepper: Stepper,
				venue_info: VenueInfo,
			},
			isOpen: false,
			menu: this.menuData
		};
	},
	mounted() {
		document.body.classList.add('has-secondary-nav');

		const eventNames = ['toggle-secondary-nav', 'get-updated-menu'];
		eventNames.forEach(eventName => {
			if(!window.EventBusEventsRegistered[eventName]) {
				window.EventBus.$on(eventName, data => {
					const localMethod = eventName.replace(/-([a-z])/g, (
							match,
							letter
					) => letter.toUpperCase());
					this[localMethod](data);
				});
				window.EventBusEventsRegistered[eventName] = true;
			}
		})
	},
	computed: {
		backdrop() {
			return document.getElementById('secondary-nav-backdrop');
		},
		breakpoint() {
			return this.$vuetify.breakpoint.name;
		},
		clickOutsideOptions() {
			const secondaryNavOpener = document.querySelector('.secondary-nav-opener');
			if(secondaryNavOpener) {
				return {
					handler: this.closeSideNav,
					include: [secondaryNavOpener]
				};
			}
		},
		isAdmin() {
			return !!this.user?.is_admin;
		},
	},
	methods: {
		closeSideNav() {
			this.isOpen = false;
			document.body.classList.remove('side-nav--open');
		},

		extractUrlParts() {
			const path = window.location.pathname;
			const segments = path.split('/').filter(Boolean); // filter(Boolean) removes any empty strings

			return {
				portal: segments[0] || undefined,
				partnerId: segments[1] || undefined,
				location: segments[2] || undefined,
				entityId: segments[3] || undefined,
				method: segments[4] || undefined
			};
		},

		getClass(type) {
			return type
					.split('-')
					.map(str => `${str.charAt(0).toUpperCase()}${str.slice(1)}`)
					.join('');
		},

		async getUpdatedMenu() {
			const { entityId, location, method, partnerId, portal } = this.extractUrlParts();

			if(!partnerId || !entityId || !method) return false;
			try {
				const { data: { data: menu = null } } = await axios.post(
						`/${portal}/${partnerId}/${location}/get-menu-data/${entityId}/${method}`
				);

				if(menu)
					this.menu = menu;
			}
			catch (error) {
				console.error('Error adding place:', error);
			}
		},

		toggleSecondaryNav(data = null) {
			this.isOpen = !this.isOpen;
		}
	},
	beforeDestroy() {
		const eventNames = ['toggle-secondary-nav', 'get-updated-menu'];
		eventNames.forEach(eventName => {
			if(window.EventBusEventsRegistered[eventName]) {
				delete window.EventBusEventsRegistered[eventName];
				window.EventBus.$off(eventName);
			}
		});
	},
	destroyed() {
		document.body.classList.remove('has-secondary-nav');
	},
	watch: {
		breakpoint: {
			handler(newValue, oldValue) {
				if(['lg', 'xl'].includes(oldValue) && ['xs', 'sm', 'md'].includes(newValue))
					this.isOpen = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
#secondary-nav {
	height: calc(100vh - 56px) !important;
	overflow-x: hidden;
	overflow-y: scroll;
	position: fixed;
	top: 56px !important;
	z-index: 10;
}

#secondary-nav-backdrop {
	background: rgb(33, 33, 33);
	height: 10000px;
	opacity: 0;
	position: fixed;
	top: 56px !important;
	transition: opacity 300ms cubic-bezier(0.25, 0.8, 0.5, 1), z-index 1ms;
	width: 10000px;
	z-index: -1;

	&.show {
		opacity: 0.46;
		z-index: 9;
	}
}

@media (min-width: 600px) {
	#secondary-nav {
		left: 56px;
	}
	.secondary-nav-opener {
		margin-top: -1rem;
	}
}

@media (min-width: 960px) {
	#secondary-nav {
		height: calc(100vh - 64px) !important;
		top: 64px !important;
	}
	#secondary-nav-backdrop {
		top: 64px !important;
	}
}

.close_btn_well {
	background-color: #fafafa;
	border-radius: 0 32px 32px 0;
	left: calc(100% - 1px);
	height: 64px;
	padding: 13px 13px 13px 0;
	position: absolute;
	top: 0;
	width: 51px;
	z-index: 1;

	& button {
		position: absolute;
		top: 13px;
		right: 13px;
	}
}
</style>
